import { CeoDto } from "./doc-entities/ceo-dto";
import { CompanyDto } from "./doc-entities/company-dto";
import { SigneeDto } from "./doc-entities/signee-dto";

export class OrganizationDto {
  id = -1;
  name = '';
  isDeleted = false;
  isContractSigned = false;
  maxUserCount: number | null = null;
  performCostCalculations: boolean = false;
  performPPWR : boolean = false;
  performExcelDownload: boolean = false;
  address?: string | null = null;
  postCode?: string | null = null;
  city?: string | null = null;
  location?: string | null = null;
  signeeProfiles?: SigneeDto[] = [];
  ceoProfiles?: CeoDto[] = [];
  manufacturerProfiles?: CompanyDto[] = [];
  authorizedRepresentativeProfiles?: CompanyDto[] = [];
}
